module.exports = __webpack_public_path__ + "media/images/feature/feature-cm-030c55e8fe1f4c62b95103de5fae7472.jpg";